import { StringValidation } from '../../../../../utils/component-validations';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

export default class SpdsModalStandardHeaderTitle extends Super {
  arguments = [new StringValidation({ required: ['title'] })];
  baseClass = 'spds-modal-standard-header-title';
  componentName = 'Spds::Modal::Announcement::Media::Title';

  <template>
    <FlexRow
      @tag="h1"
      class={{this.classes}}
      data-test-spds-modal-standard-header-title
      {{this.validateArguments}}
      ...attributes
    >
      {{@title}}
    </FlexRow>
  </template>
}
